import { BASE_URL } from '../../../../../../../utils/config.base-url'

export const PROJECT_TASK_PREFIX_URL = '/task'
export const URL_ENDPOINT_PROJECT_TASK = `${BASE_URL}/project-task`
